import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// 🔇 Suppress ResizeObserver loop errors globally
const originalConsoleError = console.error;
console.error = function (...args) {
  if (
    typeof args[0] === "string" &&
    (
      args[0].includes("ResizeObserver loop limit exceeded") ||
      args[0].includes("ResizeObserver loop completed with undelivered notifications")
    )
  ) {
    return; // Do nothing, suppress this specific error
  }
  originalConsoleError.apply(console, args); // Log all other errors
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
 
  <React.StrictMode>
    <App />
  </React.StrictMode>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
